<div class="flex flex-col max-h-[90vh]">
  <div class="flex items-center justify-between px-5 pt-5 pb-2">
    <h2 class="text-xl font-semibold">Nuevo lead</h2>
    <button mat-icon-button mat-dialog-close aria-label="Cerrar">
      <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>

  <form [formGroup]="form" class="flex flex-col gap-3 px-5 pb-2 overflow-y-auto" (ngSubmit)="save()">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Teléfono / WhatsApp</mat-label>
      <input matInput formControlName="phone" type="tel" inputmode="tel" autocomplete="off" placeholder="9999-8888 o +504 9999 8888" cdkFocusInitial>
      @if (checkingPhone) {
        <mat-spinner matSuffix diameter="18"></mat-spinner>
      }
      @if (phoneCheck?.phoneDisplay) {
        <mat-hint>{{ phoneCheck.phoneDisplay }}</mat-hint>
      }
    </mat-form-field>

    <div class="flex flex-wrap gap-2">
      @if (canReadClipboard) {
        <button type="button" mat-stroked-button (click)="pasteFromWhatsApp()">
          <mat-icon class="text-green-600" [svgIcon]="'heroicons_outline:clipboard-list'"></mat-icon>
          <span class="ml-2">Pegar de WhatsApp</span>
        </button>
      }
      @if (canPickContact) {
        <button type="button" mat-stroked-button (click)="pickContact()">
          <mat-icon [svgIcon]="'heroicons_outline:users'"></mat-icon>
          <span class="ml-2">Mis contactos</span>
        </button>
      }
    </div>
    @if (pasteHint) {
      <div class="text-sm text-secondary">{{ pasteHint }}</div>
    }

    @if (phoneCheck?.openLeads?.length) {
      <div class="rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
        <div class="font-medium mb-1">Ya hay un lead abierto con este número</div>
        @for (lead of phoneCheck.openLeads; track lead.id) {
          <button type="button" class="block w-full text-left underline" (click)="openLead(lead.id)">
            {{ lead.code }} · {{ lead.contactName || 'Sin nombre' }} · {{ lead.stageName }} ({{ lead.userName }})
          </button>
        }
      </div>
    } @else if (phoneCheck?.customers?.length) {
      <div class="rounded-lg bg-gray-100 p-3 text-sm">
        Cliente registrado: <span class="font-medium">{{ phoneCheck.customers[0].fullName }}</span>
        @if (phoneCheck.customers[0].rtn) { <span class="text-secondary"> · RTN {{ phoneCheck.customers[0].rtn }}</span> }
      </div>
    }

    <div class="flex flex-col gap-1">
      <span class="text-sm font-medium">Tipo de lead</span>
      <div class="grid grid-cols-2 gap-2">
        <button type="button" mat-stroked-button class="h-12"
          [class.bg-indigo-50]="form.controls.leadType.value === LeadType.Proyecto"
          [class.border-indigo-500]="form.controls.leadType.value === LeadType.Proyecto"
          (click)="setType(LeadType.Proyecto)">Proyecto</button>
        <button type="button" mat-stroked-button class="h-12"
          [class.bg-teal-50]="form.controls.leadType.value === LeadType.VentaInsumos"
          [class.border-teal-500]="form.controls.leadType.value === LeadType.VentaInsumos"
          (click)="setType(LeadType.VentaInsumos)">Venta de insumos</button>
      </div>
      @if (form.controls.leadType.touched && form.controls.leadType.invalid) {
        <span class="text-sm text-warn">Selecciona el tipo de lead</span>
      }
    </div>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Nombre (opcional)</mat-label>
      <input matInput formControlName="contactName" autocomplete="off">
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Origen</mat-label>
      <mat-select formControlName="typeOriginId">
        <mat-option [value]="null">Sin especificar</mat-option>
        @for (origin of origins; track origin.id) {
          <mat-option [value]="origin.id">{{ origin.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Nota (opcional)</mat-label>
      <textarea matInput formControlName="note" rows="2" (paste)="onNotePaste($event)" placeholder="¿Qué necesita? También puedes pegar aquí mensajes copiados de WhatsApp"></textarea>
    </mat-form-field>

    @if (existingLead) {
      <div class="rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 flex flex-col gap-2">
        <div>Ya existe el lead <span class="font-medium">{{ existingLead.code }}</span> con este teléfono.</div>
        <div class="flex flex-wrap gap-2">
          <button type="button" mat-flat-button color="primary" (click)="openLead(existingLead.id)">Abrir lead existente</button>
          <button type="button" mat-stroked-button (click)="save(true)">Crear uno nuevo de todas formas</button>
        </div>
      </div>
    }
  </form>

  <div class="flex justify-end gap-2 px-5 py-4 border-t">
    <button mat-button mat-dialog-close type="button">Cancelar</button>
    <button mat-flat-button color="primary" type="button" [disabled]="saving" (click)="save()">
      @if (saving) { <mat-spinner diameter="18" class="mr-2"></mat-spinner> }
      Crear lead
    </button>
  </div>
</div>
